import 'highlight.js/styles/atom-one-dark.css'
import { createApp } from 'vue'
import App from './App.vue'

createApp(App).mount('#app')
